module.exports = __webpack_public_path__ + "static/media/Feb_2026_1.a0736c4e.webp";